import React, { useEffect } from 'react';
import { Modal, Spinner } from '@economic/gaudi';
import ModalFooter from './ModalFooter';
import useQuery from '../../../../shared/hooks/useQuery';
import { useLocation } from 'react-router-dom';

interface Props {
    onCancel: () => void;
    onDone: () => void;
    onError: () => void;
}

export default function StepOnboard({ onDone, onCancel, onError }: Props) {
    const location = useLocation();
    const { campaignCallbackData } = location.state || ({} as any);
    const getOnboadingUrl = campaignCallbackData
        ? `/moneyflow/company/getOnboardingUrl?campaignCallbackData=${campaignCallbackData}`
        : `/moneyflow/company/getOnboardingUrl`;
    const { loading: onboardingUrlLoading, data: onboardingUrl, error } = useQuery<string>(getOnboadingUrl);

    useEffect(() => {
        if (!onboardingUrlLoading && !onboardingUrl) {
            onError();
        }
    }, [onboardingUrlLoading]);

    function frameNavigated(e) {
        if (e.target.contentDocument) {
            let targetUrl: string = e.target.contentDocument.location.href;
            if (targetUrl.indexOf('status=close') > -1) {
                onCancel();
            } else if (targetUrl.indexOf('status=accept') > -1) {
                onDone();
            }
        }
    }

    if (onboardingUrlLoading) {
        return (
            <div className="flex flex-col items-center">
                <Spinner />
            </div>
        );
    }

    if (error) {
        return <div className="moneyflow__onboarding moneyflow__onboarding__onboard_error">{error.toString()}</div>;
    }

    return (
        <>
            <Modal.Content>
                <div className="moneyflow__onboarding moneyflow__onboarding__content moneyflow__onboarding__onboard">
                    <iframe
                        className="border-0 absolute left-0 right-0 top-0"
                        src={onboardingUrl}
                        onLoad={frameNavigated}
                        title="Moneyflow"
                    />
                </div>
            </Modal.Content>
            <ModalFooter />
        </>
    );
}
